var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.88,
    height: 160.198,
    viewBox: "0 0 149.88 160.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c,.e{fill:none;}.b{stroke:#898b8d;stroke-width:2px;}.b,.c{stroke-linecap:round;}.c,.e{stroke:#000;}.d{fill:#464646;font-size:12px;font-family:Barlow-SemiBold, Barlow;font-weight:600;letter-spacing:0.028em;}.f{filter:url(#e);}.g{filter:url(#c);}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 13.801,
    y: 11.558,
    width: 136.079,
    height: 148.641,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 8.202,
    y: 5.959,
    width: 136.079,
    height: 148.641,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 0,
    y: 0,
    width: 136.079,
    height: 148.641,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15099 -8739.667)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 15099, 8739.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.85,0H108.03c.261,0,4.719.01,5.4.071,4.762.354,4.649.49,4.649,5.779V124.791c0,5.55-.3,5.85-5.85,5.85H5.85c-5.55,0-5.85-.3-5.85-5.85V5.85C0,.3.3,0,5.85,0Z",
    transform: "translate(22.8 17.56)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 15099, 8739.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.85,0H108.03c.261,0,4.719.01,5.4.071,4.762.354,4.649.49,4.649,5.779V124.791c0,5.55-.3,5.85-5.85,5.85H5.85c-5.55,0-5.85-.3-5.85-5.85V5.85C0,.3.3,0,5.85,0Z",
    transform: "translate(17.2 11.96)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 15099, 8739.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.85,0H108.03c.261,0,4.719.01,5.4.071,4.762.354,4.649.49,4.649,5.779V124.791c0,5.55-.3,5.85-5.85,5.85H5.85c-5.55,0-5.85-.3-5.85-5.85V5.85C0,.3.3,0,5.85,0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H72.652",
    transform: "translate(15130.449 8787.623)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 72.886,
    transform: "translate(15130.449 8800.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H72.652",
    transform: "translate(15130.449 8812.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H44.791",
    transform: "translate(15130.449 8823.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M394.494,382.25c-4.882.444-10.207,9.763-5.769,11.094s7.544-3.55,7.544-3.55.444,4.438,1.775,3.55,2.6.633,1.838-2.41a18.96,18.96,0,0,0-1.838-4.817l5.642,7.227s-.254,4.693-2.029,4.185,0-6.594,2.029-7.735a45.277,45.277,0,0,0,5.071-3.677s-2.029,4.817,0,3.677a14.338,14.338,0,0,0,3.8-3.677v3.677s1.268,2.155,3.043,0,3.043.887,4.057,0",
    transform: "translate(14788.176 8461.675)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(15165.047 8769.143)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.483,
    y: 0
  }, "Contrato")), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M15118.287,8832.153s3.031-10.965,3.5-15.4-7.7-4.433-3.5,1.867,5.831,7.232,5.831,13.53-4.664,15.632-4.2,7.232,3.732-12.131,4.2-14.932,4.667-1.167,4.433,1.168-1.167,6.533-1.866,2.565,6.531-9.333,6.3-4.666-1.867,4.433,0,5.834,2.565-2.8,2.565-2.8v-3.033a4.638,4.638,0,0,0,1.167,4.666c2.1,2.1,2.566-6.065,2.566-6.065s1.167-2.8,1.867,0a15.6,15.6,0,0,1,0,6.065s.933-5.366,2.8-6.065,1.4,6.065,1.4,6.065.7-3.967,2.566-3.733,1.866,6.3,3.733,4.9a3.929,3.929,0,0,0,1.864-2.8",
    transform: "translate(9.228 24.37)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrato);
export default __webpack_public_path__ + "static/media/contrato.4b8d7ce69c2451ada553e5442a429eed.svg";
export { ForwardRef as ReactComponent };